import React, { Fragment, useState } from 'react';
import { Modal } from './Modal';
import { FormSelect } from '../form/FormSelect';
import { Button } from '../Button';
import { FormDate } from 'components/form/FormDate';
import { FormGroup } from 'components/form/FormGroup';
import { parseISO } from 'date-fns';
import { Requires } from 'components/user/Requires';
import { useDealStageOptions } from 'components/StageSelect';
import { getStatusOptions } from 'components/StatusSelect';
import { FormField } from 'components/form/FormField';
import { FormInput } from 'components/form/FormInput';
import { useUser } from 'components/user/UserProvider';
import './ModalExport.scss';
/**
 * @component ModalExport
 * @since 1.0.0
 * @hidden
 */
export function ModalExport(props) {
    const { onClose, processing, exportType, statusType, isSaleItem, onOptionConfigurationChange } = props;
    const user = useUser();
    const dealStageOptions = useDealStageOptions();
    const [dateFrom, setDatefrom] = useState(null);
    const [dateTo, setDateto] = useState(null);
    /**
     * @function onDateFromChange
     * @since 1.0.0
     * @hidden
     */
    const onDateFromChange = (value) => {
        setDatefrom(value);
    };
    /**
     * @function onDateToChange
     * @since 1.0.0
     * @hidden
     */
    const onDateToChange = (value) => {
        setDateto(value);
    };
    const exportTypeOptions = [{ label: t('CSV (Excel)'), value: 'CSV' }];
    if (user.can('export.acomba')) {
        exportTypeOptions.push({ label: t('Acomba'), value: 'ACOMBA' });
    }
    const footerActions = (React.createElement(Fragment, null,
        React.createElement(Button, { label: t('Cancel'), onPress: onClose, noPadding: true }),
        React.createElement("div", { className: "modal-export-button-container" },
            React.createElement(Button, { picto: "download", style: "primary", label: t('Export'), disabled: processing, processing: processing, submit: true }))));
    return (React.createElement("div", { className: "modal-export" },
        React.createElement(Modal, { picto: "download", title: t('Create Export'), onClose: onClose, showFooterAction: true, footerActions: footerActions },
            React.createElement("div", { className: "modal-export-content" },
                isSaleItem && (React.createElement(Requires, { permission: ['saleItemVariant.manage'] },
                    React.createElement(FormGroup, null,
                        React.createElement(FormField, null,
                            React.createElement(FormSelect, { name: "optionConfiguration", label: t('Data Type'), placeholder: t('Select the data type to export'), options: [
                                    { label: t('Products'), value: 'ITEM_ONLY' },
                                    { label: t('Variants'), value: 'VARIANT' },
                                    { label: t('Product Options'), value: 'ITEM_OPTIONS' },
                                    { label: t('Variant Options'), value: 'VARIANT_OPTIONS' },
                                    { label: t('Option Relations'), value: 'ITEM_RELATIONS' },
                                    {
                                        label: t('Product Option Relations'),
                                        value: 'ITEM_OPTION_RELATIONS'
                                    },
                                    {
                                        label: t('Variant Option Relations'),
                                        value: 'VARIANT_OPTION_RELATIONS'
                                    }
                                ], onChange: onOptionConfigurationChange, required: true }))))),
                (exportType === 'DEAL' || exportType === 'ORDER') && (React.createElement(FormGroup, null,
                    React.createElement(FormField, null,
                        React.createElement(FormSelect, { name: "exportFormat", label: t('Export Format'), placeholder: t('Select Export Format'), value: 'CSV', options: exportTypeOptions })))),
                React.createElement(FormGroup, null,
                    React.createElement(FormField, null,
                        React.createElement(FormSelect, { name: "separator", label: t('Column Separator'), placeholder: t('Select Column Separator'), options: [
                                { label: t('Coma'), value: ',' },
                                { label: t('Semicolon'), value: ';' }
                            ], required: true }))),
                (exportType === 'DEAL' || exportType === 'ORDER') && (React.createElement(React.Fragment, null,
                    React.createElement(FormGroup, null,
                        React.createElement(FormField, null,
                            React.createElement(FormInput, { name: "number", label: t('Number'), placeholder: t('Enter deal number to export') }))),
                    React.createElement(FormGroup, { className: "modal-export-from-group" },
                        React.createElement(FormField, null,
                            React.createElement(FormDate, { name: "dateFrom", label: t('From'), time: false, onChange: onDateFromChange, maxDate: dateTo ? parseISO(dateTo) : undefined })),
                        React.createElement(FormField, null,
                            React.createElement(FormDate, { name: "dateTo", label: t('To'), time: false, onChange: onDateToChange, minDate: dateFrom ? parseISO(dateFrom) : undefined }))),
                    React.createElement(FormGroup, { className: "modal-export-from-group" },
                        React.createElement(FormField, null,
                            React.createElement(FormSelect, { name: "status", label: t('Status'), placeholder: t('Select Status'), options: getStatusOptions(statusType !== null && statusType !== void 0 ? statusType : 'DEAL') })),
                        React.createElement(FormField, null,
                            React.createElement(FormSelect, { name: "stage", label: t('Stage'), placeholder: t('Select Stage'), options: dealStageOptions })))))))));
}
